export const AUTH_TOKEN = 'Authorization';

export const LOCAL_STORAGE = {
  ID_TOKEN: 'token',
  USER: 'user',
};

export const TITLES = {
  WEBSITE_TITLE: 'Koostream',
}

export const MESSAGES = {
  EMAIL_SUCCESS: 'Your email has been sent successfully!',
  EMAIL_FAILURE: 'Unable to sent email!',
  ADD_STREAM_SUCCESS: 'Player added successfully!',
  ADD_STREAM_FAILURE: 'Failed to add player!',
  UPDATE_STREAM_SUCCESS: 'Streams updated successfully!',
  UPDATE_STREAM_FAILURE: 'Failed to add sreeams!',
  AUTH_SUCCESS: 'User Authenticated!',
  AUTH_FAILURE: 'Invalid user or password!'
}

export const NOT_SOCCER = ['tennis', 'cricket', 'f1', 'boxing|ufc', 'nfl', 'motogp','nba', 'nhl', 'mlb', 'rugby', 'wwe','ufc'];

export const categories = [
  {
    label: 'Soccer',
    value: 'Streams today'
  },
  {
    label: 'F1',
    value: 'F1'
  },
  {
    label: 'tennis',
    value: 'tennis'
  },
  {
    label: 'Boxing',
    value: 'Boxing'
  },
  {
    label: 'MMA',
    value: 'MMA'
  },
  {
    label: 'motogp',
    value: 'motogp'
  },
  {
    label: 'NFL',
    value: 'NFL'
  },
  {
    label: 'NBA',
    value: 'NBA'
  },
  {
    label: 'MLB',
    value: 'MLB'
  },
  {
    label: 'NHL',
    value: 'NHL'
  },
  {
    label: 'Rugby',
    value: 'Rugby'
  },
  {
    label: 'Cricket',
    value: 'cricket'
  }
];

// export const CATGORY_LINKS = [
//   { label: 'Soccer', link: '/' },
//   { label: 'mlb', link: '/fixtures/MLB/MLB' },
//   { label: 'NFL', link: '/fixtures/NFL/NFL' },
//   { label: 'NBA', link: '/fixtures/NBA/NBA' },
//   { label: 'Boxing', link: '/fixtures/Boxing/Boxing' },
//   { label: 'MMA', link: '/fixtures/MMA/MMA' },
//   { label: 'F1', link: '/fixtures/F1/F1' },
//   { label: 'nhl', link: '/fixtures/NHL/NHL' },
// ];

export const CATGORY_LINKS = [
  { label: 'Home', link: '/' },
  { label: 'NFL', link: '/fixtures/NFL/NFL' },
  { label: 'F1', link: '/fixtures/F1/F1' },
  { label: 'UFC', link: '/fixtures/UFC/UFC' },
  { label: 'Boxing', link: '/fixtures/Boxing/Boxing' },
  { label: 'tennis', link: '/fixtures/tennis/tennis' },
  { label: 'NBA', link: '/fixtures/NBA/NBA' },
  { label: 'Rugby', link: '/fixtures/Rugby/Rugby' },
  { label: 'Cricket', link: '/fixtures/cricket/Cricket' },
  { label: 'motogp', link: '/fixtures/motogp/MOTOGP' },
  { label: 'mlb', link: '/fixtures/MLB/MLB' },
  { label: 'nhl', link: '/fixtures/NHL/NHL' },
];

export const ADS = {
  MAIN: {
    TYPE: 'main',
    SLOT: '2554300823'
  },
  FIXTURE_LIST_DISPLAY_HORIZONTAL: {
    TYPE: 'FixtureListDisplayHorizontal',
    SLOT: '3824669050'
  },
  PLAYER_DISPLAY_HORIZONTAL: {
    TYPE: 'playerDisplayHorizontal',
    SLOT: '3744778007'
  },
  VERTICLE_MAIN: {
    TYPE: 'vertical',
    SLOT: '2926488530'
  },
  IN_ARTICLE: {
    TYPE: 'in-article',
    SLOT: '6685754230'
  },
  IN_FEED: {
    TYPE: 'in-feed',
    SLOT: '2184823320'
  },
  SQUARE_DISPLAY: {
    TYPE: 'square-display',
    SLOT: '7807264218'
  },
}

export const PAGE_TITLES: any = {
  WEBSITE_TITLE: 'Soccer Streams | Football Streams |  Live Sports and Entertainment| Koostream.com',
  SOCCER: 'Koostream - Live Soccer Streams and Today\'s Soccer Fixtures | Koostream.com',
  BOXING: 'Live Boxing Streams and Upcoming Matches | Koostream.com',
  NFL: 'Live NFL Streams and Upcoming NFL Fixtures | Koostream.com',
  NBA: 'NBA Streams and Live Fixtures | Koostream.com',
  UFC: 'UFC Streams and Upcoming UFC Events | Koostream.com',
  TENNIS: 'Live Tennis Streams and Upcoming Tennis Fixtures | Koostream.com',
  RUGBY: 'Live Rugby Streams and Upcoming Rugby Fixtures | Koostream.com',
  MOTOGP: 'MotoGP Streams and Live Fixtures | Koostream.com',
  NHL: 'NHL Streams and Today\'s Fixtures | Koostream.com',
  MLB: 'MLB Streams and Upcoming Matches | Koostream.com',
  F1: 'Live F1 Streams and Fixtures | Koostream.com',
  MLS: 'MLS Streams and Live Match Schedules | Koostream.com',
  CRICKET: 'Watch Live Cricket Matches and Match Schedules | Koostream.com',
  TEAMS: 'Explore Upcoming Fixtures of Popular Teams | Koostream.com',
  LEAGUES: 'Discover Upcoming Fixtures of Your Favorite Leagues | Koostream.com',
  STANDINGS: 'Points Table for Premier League, La Liga, Bundesliga, and More | Koostream.com',
  CONTACT: 'Contact Us for Support and Feedback | Koostream.com',
  ABOUT: 'Learn About Our Mission and Vision | Koostream.com',
  BLOGS: 'Latest Sports News and Feed | Koostream.com'
};

export const blogs = [
  {
    title: 'Pierluigi Collina on his career’s most moving moment',
    url: 'Pierluigi-Collina-on-his-careers-most-moving-moment',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/F_njnFaWcAA8vDD.jpg',
    description: 'In the final two minutes, I watched the Bayern players on the bench, ready to celebrate their title. The fans in the stands were embracing, waiting for my final whistle.',
    authorIcon: 'https://randomuser.me/api/portraits/men/32.jpg',
    date: '2024-10-30',
    id: 8
  },
  {
    title: 'The Saddest moments in Football',
    url: 'The-Saddest-moments-in-Football',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/sddefault.jpg',
    description: 'The Saddest Moments in Football History often remind us how deeply players and fans connect. ',
    authorIcon: 'https://randomuser.me/api/portraits/men/32.jpg',
    date: '2024-10-30',
    id: 7
  },
  {
    title: 'Downfall of Man City',
    url: 'the-downfall-of-man-city',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/downfall-of-man-city.jpeg',
    description: 'Very few women basket players have been successful to get the international popularity and name. For years the women basketball players have been struggled to get the recognition that the male basketball players have got over decades. ',
    authorIcon: 'https://randomuser.me/api/portraits/men/32.jpg',
    date: '2024-10-30',
    id: 6
  },
  {
    title: 'The Caitlin Clark Effect ',
    url: 'the-caitlin-clark-effect',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/the-caitlin-clark-effect.webp',
    description: 'Very few women basket players have been successful to get the international popularity and name. For years the women basketball players have been struggled to get the recognition that the male basketball players have got over decades. ',
    authorIcon: 'https://randomuser.me/api/portraits/men/32.jpg',
    date: '2024-10-30',
    id: 5
  },
  {
    title: 'How the new champion’s league format has fared so far',
    url: 'How-the-new-champion’s-league-format-has-fared-so-far',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/Champions-League2.webp',
    description: 'The 2024/2025 UEFA Champions League has lived up to its reputation as Europe’s premier football competition, delivering drama, surprise results, and standout performances as the tournament heads into its latter stages. The group stage, now well underway, has featured several thrilling encounters, with new contenders rising, established powers flexing their muscle, and some underdog stories grabbing headlines.',
    authorIcon: 'https://randomuser.me/api/portraits/men/32.jpg',
    date: '2024-10-30',
    id: 1
  },
  {
    title: 'The rise of Calafiori at Arsenal:',
    url: 'The-rise-of-Calafiori-at-Arsenal',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/Calafiori.webp',
    description: 'Riccardo Calafiori is making waves at Arsenal, having joined from Bologna in a move that strengthens the club’s defense. The Italian defender is eager to make a significant impact in the Premier League, thriving under the pressure of high expectations. Ricardo Calafiori’s impact at Arsenal, following his move to North London, has been both promising and crucial in adding depth and quality to Mikel Arteta’s squad. The young Italian left-back, signed to provide competition and cover for Kieran Tierney and Oleksandr Zinchenko, has quickly shown why Arsenal sought his services. His performances so far have reflected his potential to become a key player for the Gunners in the long term.',
    authorIcon: 'https://randomuser.me/api/portraits/women/44.jpg',
    date: '2024-09-18',
    id: 2
  },
  {
    title: 'Key Players Lighting Up the Stage',
    url: 'Key-Players-Lighting-Up-the-Stage',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/Champions-League.webp',
    description: 'As always, the Champions League has been a showcase for the world’s best talents. Jude Bellingham has been one of the standout players for Real Madrid, continuing his incredible development as one of Europe’s top midfielders. His goals and leadership have been crucial for Madrid’s early success. Harry Kane, now at Bayern Munich, has looked every bit the elite striker the Bavarians hoped for when they signed him in the summer. His goal-scoring exploits have kept Bayern among the favorites for the title.',
    authorIcon: 'https://randomuser.me/api/portraits/men/85.jpg',
    date: '2024-09-20',
    id: 3
  },
  {
    title: 'Has Martin Odeegard’s injury been a blessing in disguise for The Arsenal or is it Arsenal’s misfortune?',
    url: 'Has-Martin-Odeegard-injury-been-a-blessing-in-disguise-for-The-Arsenal-or-is-it-Arsenal-misfortune',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/blog2.webp',
    description: 'Arsenal Captain Martin Odegaard has been injured for a couple of games now and he is yet to seen back onto the pitch to captain the Arsenal.  Martin Odeegard’s Injury Has Forced Arsenal to Be Different with Leandro Trossard coming in for the top-flight games missed by Martin Odegaard, as well as the Champions League win over Paris Saint-Germain this week and came on as a sub in the away game at Southampton contributing heavily towards Arsenals third goal scored by Saka.',
    authorIcon: 'https://randomuser.me/api/portraits/men/63.jpg',
    date: '2024-09-22',
    id: 4
  },
  {
    title: 'Violent Clash among Football Fans',
    url: 'Violent-Clash-among-Football-Fans',
    image: 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/blogs/p0c9r9b6.webp',
    description: 'Football, often referred to as "the beautiful game," has captivated millions around the world.',
    authorIcon: 'https://randomuser.me/api/portraits/men/32.jpg',
    date: '2025-02-17',
    id: 9
  },
];

export const DEFAULT_SPORTS_LOGO = 'https://res.cloudinary.com/djfixkqyj/image/upload/v1709307398/Images/Default-Sports-Logo_luku1o.webp';
export const DEFAULT_LEAGUE_LINK = '/fixtures/league/Premier League';
export const DEFAULT_TEAM_LINK = '/fixtures/team/Liverpool';
export const LOGO_URL2 = 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/koostream-official-logo-final.webp';
export const LOGO_URL = 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/koostream-website-logo-final.webp';
export const LOGO_URL1 = 'https://d22vy4ldq8bjtm.cloudfront.net/images/koostream/Logo-final.webp';
